import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import IndexDetailView from 'src/components/Dashboard/components/IndexDetailView';
import ReferralsIndex from 'src/components/Dashboard/components/New/ReferralsIndex';
import { fetchDashboardReferrals } from 'actions/Referral/Group';
import _ from 'lodash';
import DetailView from 'src/components/Dashboard/components/DetailView';
import { fetchGroupsPrograms } from 'actions/Program/Group';
import fetchProvidersUserCore from 'src/actions/UserProvider/fetchProvidersUser';
import ReferralDetail from 'src/components/Referrals/ReferralDetail/index';
import { noneAssignedOption } from 'src/components/Dashboard/utils/filterDefaults';
import { getDataOfPage, isDataValid, getResponsePageMismatch } from 'src/components/Dashboard/utils/dataHelpers';
import appendReferralIdToLocation from 'src/components/Dashboard/utils/appendReferralIdToLocation';
import { goToReferral } from 'src/components/Referrals/utils/routing';
import {
  serviceTypesFilter,
  careCoordinatorsFilter,
  programsFilter,
} from 'src/components/Dashboard/utils/filter';
import { getGroupUsersOptions } from 'src/components/Groups/Users/utils';
import { getProgramsOptions } from 'src/components/Groups/Programs/utils';
import FeatureFlagContainer from 'src/common/utils/FeatureFlags/FeatureFlagContainer';
import { crtb2646ShowProgramNameReferralsCasesDashboard } from 'src/common/utils/FeatureFlags/flags';
import { isReferralsAdminAndAbove } from 'src/components/User/utils';
import labelCustomization from 'src/common/utils/Customization/labels';
import defaultLabels from 'src/constants/labels';
import { createSortChangeHandler } from 'src/components/Dashboard/utils/sortHelpers';
import { loadDashboardSortingConfiguration } from 'src/components/Dashboard/utils/userSortingHandler';
import { browserHistory } from 'common/utils/browserHistory';

export class NewReferrals extends Component {
  constructor(props) {
    super(props);
    this.onCellClick = this.onCellClick.bind(this);
    this.onFiltersChange = this.onFiltersChange.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.onPrevClick = this.onPrevClick.bind(this);
    this.shouldFetch = this.shouldFetch.bind(this);
    this.fetch = this.fetch.bind(this);
    this.fetchGroupsUsers = this.fetchGroupsUsers.bind(this);
    this.fetchProgramsSearch = this.fetchProgramsSearch.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
    this.fetchRequestId = 0;
    const sortObj = loadDashboardSortingConfiguration(browserHistory.getCurrentLocation().pathname);
    this.state = {
      activeUsersInGroup: [],
      activePrograms: [],
      page: 1,
      sidx: sortObj?.column || 'received_at',
      sord: sortObj?.sortDirection || 'desc',
      source: props.location?.state?.source || '',
      filters: {
        service_types: _.get(props, 'filters.service_types', []),
        care_coordinator_users: _.get(props, 'filters.care_coordinator_users', []),
        programs: _.get(props, 'filters.programs_filter', []),
      },
    };
  }

  componentDidMount() {
    if (isReferralsAdminAndAbove(this.props.user, this.props.groupId)) {
      this.fetch();
    }
    this.props.fetchProvidersUserCore({
      providers: this.props.groupId,
    }).then((response) => {
      if (response) {
        const { employees: activeUsersInGroup } = response;
        this.setState({ activeUsersInGroup });
      }
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.refetch && nextProps.refetch) {
      this.fetch(this.state.page);
    }
  }

  onSortChange = createSortChangeHandler(this);

  onCellClick(row) {
    const pagedData = getDataOfPage(this.props.newReferrals, this.state.page);
    const referral = pagedData.data[row];

    goToReferral(referral);
  }

  onFiltersChange(key, activeFilters, callbacks) {
    let newFilters = activeFilters;
    if (_.isEqual(key, 'care_coordinator_users')) {
      newFilters = careCoordinatorsFilter(activeFilters, callbacks);
    }
    if (_.isEqual(key, 'programs_filter')) {
      newFilters = programsFilter(activeFilters, callbacks);
    }

    this.setState({
      page: 1,
      filters: _.assign({}, this.state.filters, { [key]: newFilters }),
    }, () => {
      this.fetch();
    });
  }

  onNextClick() {
    const page = this.state.page + 1;
    this.fetch(page);
  }

  onPrevClick() {
    const page = this.state.page - 1;
    this.fetch(page);
  }

  shouldFetch(page) {
    if (isDataValid(this.props.newReferrals, page)) {
      this.setState({ page });
    } else {
      this.fetch(page);
    }
  }

  fetch(page = 1) {
    const requestId = this.fetchRequestId + 1;
    this.fetchRequestId = requestId;
    this.setState({ page });
    const referralsPromise = Promise.resolve(this.props.fetchDashboardReferrals(
      this.props.groupId,
      'received/pending',
      {
        target: 'newReferrals',
        sidx: this.state.sidx,
        sord: this.state.sord,
        filters: this.state.filters,
        page,
      },
      'pending',
      'received',
    )).then((response) => {
      if (requestId !== this.fetchRequestId) {
        return response;
      }

      const responsePage = getResponsePageMismatch(response, page);
      if (responsePage !== null) {
        this.setState({ page: responsePage });
      }

      return response;
    });
    return Promise.all([
      referralsPromise,
      this.props.fetchGroupsPrograms(this.props.groupId, { active: true }),
    ]).then(([, res]) => {
        this.setState({ activePrograms: res.data.data });
        return getProgramsOptions(res.data.data, this.state);
      });
  }

  fetchProgramsSearch(query = null) {
    return this.props.fetchGroupsPrograms(this.props.groupId, { active: true, query })
      .then((res) => {
        this.setState({ activePrograms: res.data.data });
        return getProgramsOptions(res.data.data, this.state);
      });
  }

  fetchGroupsUsers(search = '') {
    const { groupId } = this.props;
    return this.props.fetchProvidersUserCore({
      providers: groupId,
      options: {
        text: search,
        licensed: false,
      },
    }).then((response) => {
      if (response) {
        const { employees: activeUsersInGroup } = response;
        if (search === '') {
          return _.concat(
            [noneAssignedOption(this.state.filters.care_coordinator_users)],
            getGroupUsersOptions(activeUsersInGroup, this.state),
          );
        }

        return getGroupUsersOptions(activeUsersInGroup, this.state);
      }

      return [];
    });
  }

  render() {
    const {
      newReferrals,
      isFetching,
      isCC,
      baseLocation,
      params,
      serviceTypes,
      labels,
      showProgramNameColumn,
    } = this.props;
    const { activeUsersInGroup, activePrograms } = this.state;
    const location = appendReferralIdToLocation(baseLocation, params);

    const filters = [
      serviceTypesFilter(serviceTypes, this.state.filters.service_types),
      {
        key: 'care_coordinator_users',
        name: labels.CareCoordinator,
        pluralName: `${labels.CareCoordinator}s`,
        options: _.concat(
          [noneAssignedOption(this.state.filters.care_coordinator_users)],
          getGroupUsersOptions(activeUsersInGroup, this.state),
        ),
      },
      {
        key: 'programs_filter',
        hideSelectAll: true,
        name: 'Program',
        pluralName: 'Programs',
        options: getProgramsOptions(activePrograms, this.state),
        asyncSearch: this.fetchProgramsSearch,
      },
    ];

    const innerContentView = (
      <ReferralDetail
        subjectType="referral"
        location={location}
        params={params}
        type="newReferrals"
        showContactColumn
      />
    );

    const onBackClickHandler = this.state.source === 'referral' ?
      () => browserHistory.push('/dashboard/new/referrals') : null;

    const newReferralDetailView = (
      <DetailView
        innerContentView={innerContentView}
        onBackClick={onBackClickHandler}
      />
    );
    const pagedData = getDataOfPage(newReferrals, this.state.page);

    // the key on the IndexDetailView ties the component's identity to the referral id,
    // if it changes, the component will get cleaned up, creating a new DOM tree
    return (
      <>
        <h1 className="sr-only" id="needs-action-inbound-referrals-heading">Inbound Referrals - Needs Action</h1>
        <IndexDetailView
          key={this.props.params.id}
          params={this.props.params}
          DetailView={newReferralDetailView}
          IndexView={ReferralsIndex}
          data={pagedData.data}
          paging={pagedData.paging}
          isFetching={isFetching || pagedData.invalidated}
          onNextClick={this.onNextClick}
          onPrevClick={this.onPrevClick}
          onCellClick={this.onCellClick}
          initialSort={{ [this.state.sidx]: this.state.sord }}
          isCC={isCC}
          onFiltersChange={this.onFiltersChange}
          filters={_.sortBy(filters, 'name')}
          fetchGroupsUsers={this.fetchGroupsUsers}
          showProgramNameColumn={showProgramNameColumn}
          setSort={this.onSortChange}
          sortConfig={{
            sidx: this.state.sidx,
            sord: this.state.sord,
          }}
        />
      </>
    );
  }
}

NewReferrals.propTypes = {
  location: PropTypes.object,
  params: PropTypes.object.isRequired,
  fetchDashboardReferrals: PropTypes.func.isRequired,
  fetchGroupsPrograms: PropTypes.func.isRequired,
  newReferrals: PropTypes.shape({
    data: PropTypes.array.isRequired,
    currentPage: PropTypes.number.isRequired,
  }).isRequired,
  groupId: PropTypes.string.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isCC: PropTypes.bool.isRequired,
  baseLocation: PropTypes.string.isRequired,
  serviceTypes: PropTypes.array.isRequired,
  fetchProvidersUserCore: PropTypes.func.isRequired,
  refetch: PropTypes.bool.isRequired,
  query: PropTypes.shape({
    pending_consent: PropTypes.string,
  }).isRequired,
  user: PropTypes.object.isRequired,
  labels: PropTypes.object,
  showProgramNameColumn: PropTypes.bool.isRequired,
};

NewReferrals.defaultProps = {
  labels: defaultLabels,
  location: {},
};

function mapStateToProps(state, ownProps) {
  return {
    query: _.get(ownProps, 'location.query', {}),
    baseLocation: _.get(ownProps, 'location.pathname', ''),
    user: _.get(state, 'user', {}),
    groupId: _.get(state, 'session.groupId', ''),
    newReferrals: _.get(state, 'dashboard.newReferrals', { data: [], currentPage: 1 }),
    filters: _.get(state, 'dashboard.newReferrals.filters', {}),
    isFetching: _.get(state, 'dashboard.newReferrals.isFetching', false),
    isCC: _.wget(state, 'session.isCoordinationGroup', false),
    serviceTypes: _.wget(state, 'serviceTypes.allNetworks', []),
    refetch: _.get(state, 'dashboard.refetch', false),
    token: _.get(state, 'session.token', ''),
    labels: labelCustomization(state),
    showProgramNameColumn: crtb2646ShowProgramNameReferralsCasesDashboard(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({ fetchDashboardReferrals, fetchGroupsPrograms, fetchProvidersUserCore }, dispatch),
    dispatch,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FeatureFlagContainer(NewReferrals));
